import type { BulkDeleteTaxCodesPayload } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodBulkDeleteTaxCodesEndpointSchema,
  zodBulkDeleteTaxCodesPayloadSchema,
} from './validations';

/**
 * Deletes multiple tax codes in one all-or-nothing request.
 *
 * @param payload - One to 500 tax-code ids.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const bulkDeleteTaxCodes = async (
  payload: BulkDeleteTaxCodesPayload,
): Promise<void> => {
  await vestigasApi.post(ENDPOINT.TAX_CODE.BULK_DELETE(), {
    json: payload,
    validate: {
      body: zodBulkDeleteTaxCodesPayloadSchema,
      pathSegments: zodBulkDeleteTaxCodesEndpointSchema,
      // A 204 response has no JSON body to validate.
    },
  });
};
